export const ADMINCENTRE_TYPE = {
  MODAL: 'Modal',
  DIALOG: 'Dialog',
  LINK: 'Link',
}

export const ADMINCENTRE = {
  ACTIONMENU: [
    {
      key: 1, permission: 'ADMN: Personal Info', label: 'Personal information', path: '/admin/admincentre/personalinfo', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 2, permission: 'ADMN: Beneficiary', label: 'Beneficiaries', path: '/admin/admincentre/beneficiaries', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 3, permission: 'ADMN: Accounts and Loans', label: 'Accounts & loans', path: '/admin/admincentre/accountsandloans', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 4, permission: 'ADMN: Tax Statements', label: 'Documents', path: '/admin/admincentre/documents', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 5, permission: 'ADMN: Partner Plan', label: 'Partner plan', path: '/admin/admincentre/partnerplans/myplans', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 6, permission: 'ADMN: Update plan status', label: 'Plan status', path: '', type: ADMINCENTRE_TYPE.MODAL,
    },
    {
      key: 7, permission: 'ADMN: Update Hierarchy', label: 'Partner hierarchy', path: '', type: ADMINCENTRE_TYPE.MODAL,
    },
  ],
  SIDEBAR: [
    {
      key: 1, permission: 'ADMN: Provide Admin access', label: 'Manage permissions', path: '', type: ADMINCENTRE_TYPE.MODAL, modalId: 'managePermissions',
    },
    {
      key: 2, permission: 'ADMN: Update plan status', label: 'Partner plan administration', path: '/admin/admincentre/partnerplan/manage', type: ADMINCENTRE_TYPE.LINK,
    }, 
    {
      key: 3, permission: 'ADMN: Tax Statement upload', label: 'Check document upload status', path: '/admin/admincentre/uploadlogs/taxstatements', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 4, permission: 'ADMN: Accounts and Loans', label: 'Locked account', path: '/admin/admincentre/lockedaccount', type: ADMINCENTRE_TYPE.LINK,
    },
    /* {
      key: 4, permission: 'ADMN: Tax Statement upload', label: 'Check remuneration statements upload status', path: '/admin/admincentre/uploadlogs/remunerations', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 5, permission: 'ADMN: Tax Statement upload', label: 'Check other documents upload status', path: '/admin/admincentre/uploadlogs/others', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 6, permission: 'ADMN: Tax Statement upload', label: 'Check capital loan upload status', path: '/admin/admincentre/uploadlogs/capitalloan', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 7, permission: 'ADMN: Tax Statement upload', label: 'Check docusign upload status', path: '/admin/admincentre/uploadlogs/docusign', type: ADMINCENTRE_TYPE.LINK,
    }, */
    {
      key: 5, permission: 'ADMN: Upload beneficiary', label: 'Upload beneficiary', path: '/admin/admincentre/beneficiary/upload', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 6, permission: 'ADMN: Partner hierarchy upload', label: 'Upload hierarchy', path: '/admin/admincentre/hierarchy/upload', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 7, permission: 'ADMN: Partner Plan counselling rating upload', label: 'Upload counselling ratings', path: '/admin/admincentre/partnerplan/ratingsupload', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 8, permission: 'ADMN: Partner Plan BUL final rating upload', label: 'Upload bul final ratings', path: '/admin/admincentre/partnerplan/finalratingsupload', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 9, permission: 'ADMN: Partner Plan OL rating upload', label: 'Upload offering leader ratings', path: '/admin/admincentre/partnerplan/olratingsupload', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 10, permission: 'ADMN: Feature toggle', label: 'Feature toggle administration', path: '/admin/admincentre/featuretoggle', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 11, permission: 'ADMN: Partner Plan Notification', label: 'Send interim plan reminder email', path: '/admin/admincentre/partnerplan/remindernotification/interim', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 12, permission: 'ADMN: Partner Plan Notification', label: 'Send final plan reminder email', path: '/admin/admincentre/partnerplan/remindernotification/final', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 13, permission: 'ADMN: Send capital loan documents', label: 'Send capital loan trust deeds', path: '/admin/admincentre/templateupload/capitalloantrustdeeds', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 14, permission: 'ADMN: Send capital loan documents', label: 'Send capital loan pack', path: '/admin/admincentre/templateupload/capitalloanpack', type: ADMINCENTRE_TYPE.LINK,
    },
    {
      key: 15, permission: 'ADMN: Send capital loan documents', label: 'Send capital loan amount confirmation', path: '/admin/admincentre/templateupload/capitalloanamtconfirmation', type: ADMINCENTRE_TYPE.LINK,
    },
  ],
  SEARCHFILTER:
  {
    NAME: 'Name',
    LOCATION: 'Location',
    CODE: 'Code',
    STATUS: 'Status',
  },
}



// WEBPACK FOOTER //
// ./src/constants/admincentre.js